import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { GeneralHeaderModel } from 'src/app/model/general/header';
import { GENERAL_VITAL_SIGN_CONSTANTS } from './vital-sign.constants';
import { GeneralConsultVitalSignService } from './vital-sign.service';

@Component({
  selector: 'ms-consult-vital-sign',
  templateUrl: './vital-sign.component.html',
})
export class GeneralConsultVitalSignComponent extends BaseComponent {
  readonly screen = GENERAL_VITAL_SIGN_CONSTANTS;
  @Input() patient = -1;
  @Input() turn = -1;
  @Input() readonly = false;
  header: GeneralHeaderModel = {};
  expandSection = true;

  constructor(protected service: GeneralConsultVitalSignService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service
        .loadConsultHeader(this.turn)
        .subscribe((header) => (this.header = header))
    );

    if (!this.readonly) {
      this.subscriptions.push(
        this.service.isSaving().subscribe((saving) => {
          if (saving) {
            this.header.patient = this.patient;
            this.subscriptions.push(
              this.service
                .save(this.turn, this.header)
                .subscribe((header) => (this.header = header))
            );
          }
        })
      );
    }
  };
}
